<template>
    <el-input @change="inputChange" type="textarea" class="comment-textarea " :rows="10" placeholder="Schreibe einen Kommentar"
                    v-model.lazy="comment">
                </el-input>
</template>
<script>

    export default {
        name: 'InputTemplate',
        props: ['commentProp'],
        data () {
            return {
                comment: this.commentProp,
            };
        },
        methods: {
            inputChange () {
                this.$emit('commentChange', this.comment);
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/pages/order/InputTemplate.vue